import useComputed from '@/hooks/use-computed'
import api from '@/services/api/profile.js'
import { immerable } from "immer"
import { useState } from 'react'

class Profile {

	[immerable] = true

	constructor(params) {
		this.organization = params.organization
		this.adminRequest = params.adminRequest
		this.emailAddress = params.emailAddress
		this.fullName = params.fullName
		this.mobile_number = params.mobile_number

	}
}

const useProfile = (requestId) => {

	const [items, setItems] = useComputed([])


	const [currentItem ,setCurrentItem] = useState(null)
	const [loading, setLoadingFnc] = useState(false)
	const [error, setError] = useState()

	async function fetch(parameter) {
		setLoadingFnc(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoadingFnc(false)

		if (error) {
			return setError(error)
		}

		const serializedData = serialize(data)
		const newItem = new Profile(serializedData)
		return setCurrentItem(newItem)
	}

	async function find( parameter ) {

		setLoadingFnc(true)
		const params = parameter ? parameter : "";

		const [error, data] = await api.index({params});


		setLoadingFnc(false)

		if (error) {
			return setError(error)
		}

		return data
	}

	function serialize(entry) {
		return {
			organization: entry.organization,
			adminRequest: entry?.organization?.adminRequest,
			emailAddress: entry.email,
			fullName: entry.firstName,
			mobile_number: entry.mobileNumber
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		find
	}

}

export default useProfile;
